/**
 * Feature gating configuration.
 * Tiers are derived from Cognito user groups (Premium, Elite).
 * Features are gated by minimum tier level.
 */

export const FEATURES = {
    elis_chat: { minTier: 1 },
};

export function tierFromGroups(groups) {
    if (!groups) return 0;
    if (groups.includes('Elite')) return 2;
    if (groups.includes('Premium')) return 1;
    return 0;
}

export function tierHasFeature(tier, feature) {
    const config = FEATURES[feature];
    return config ? tier >= config.minTier : false;
}
